import { Modal } from '@mui/material'
import React, { useEffect, useState } from 'react'
import request from '../../../../Helpers/API';

export const ModalNotificacionesDetalle = ({ open, handleClose, idencabezado, ObtenerListado }) => {
    const [notificacionDetalle, setNotificacionDetalle] = useState([]);

    useEffect(() => {
        if (idencabezado !== "" && idencabezado !== null && idencabezado !== undefined && idencabezado !== -99 && idencabezado !== 0) {
            request
                .get(`ProgramarNotificacion/Listado_Detalle?idencabezado=${idencabezado}`)
                .then((result) => {
                    setNotificacionDetalle(result)
                })
                .catch((error) => {
                    console.log("Error al obtener la notificación", error);
                });
        }
    }, [idencabezado]);

    function formateoFecha(fechaEvento) {
        const fecha = new Date(fechaEvento);
        const dia = String(fecha.getDate()).padStart(2, '0');
        const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Los meses son 0-indexados
        const anio = fecha.getFullYear();
        const hora = String(fecha.getHours()).padStart(2, '0');
        const minuto = String(fecha.getMinutes()).padStart(2, '0');
        const segundo = String(fecha.getSeconds()).padStart(2, '0');

        return `${dia}/${mes}/${anio} - ${hora}:${minuto}:${segundo}`;
    }
    // console.log(notificacionDetalle)
    return (
        <Modal open={open}>
            <div className="otros-modal-2">
                {/* <LoaderScreen loader={loader} /> */}
                <div className="otros-modal-title">
                    <div className="filtro-soy-el-titulo-header">
                        <h3>DETALLE NOTIFICACIONES</h3>
                    </div>
                    <div className="cerrar-button" onClick={handleClose} style={{ cursor: "pointer" }}>
                        X
                    </div>
                </div>
                <div className="imagen-modal-soy-el-titulo-line">
                    <div className="imagen-modal-soy-el-titulo-line-bl"></div>
                    <div className="imagen-modal-soy-el-titulo-line-circle"></div>
                    <div className="imagen-modal-soy-el-titulo-line-br"></div>
                </div>
                <div className='otros-modal-container'>
                    <div className='modal-notificaciones-detalle-tabla-container scroll'>
                        <table cellSpacing={0} cellPadding={0}>
                            <thead>
                                <tr>
                                    <th>Fecha de envio</th>
                                    {/* <th>
                                    <div>Fecha</div>
                                </th> */}
                                    <th>
                                        <div>Redireccion</div>
                                    </th>
                                    {/* <th>
                                    <div>tipo</div>
                                </th> */}
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {notificacionDetalle.map((lst) => (
                                    <tr>
                                        {/* <td className="celda-mensaje">
                                        {lst.mensaje}
                                    </td> */}
                                        <td className='ta-center'>{formateoFecha(lst.fecha_evento)}</td>
                                        <td className='ta-center'>
                                            {lst.modulo}
                                        </td>
                                        {/* <td className="celda-tipo">
                                        {lst.tipo_alerta === "F" ? "Fecha Especifica" : lst.tipo_alerta === "A" ? "Primer Semana del Mes" : lst.tipo_alerta === "B" ? "Segunda Semana del Mes" : lst.tipo_alerta === "C" ? "Ultima Semana del Mes" : lst.tipo_alerta === "I" ? "Instantanea" : lst.tipo_alerta === "D" ? "Cada Dia" :
                                            lst.tipo_alerta === "H" ? "Cada 3 dias" :
                                                lst.tipo_alerta === "E" ? "Cada Semana" :
                                                    lst.tipo_alerta === "G" ? "Cada dos Semanas" :
                                                        lst.tipo_alerta === "M" ? "Cada Mes" : "Ultima Semana del Mes"}
                                    </td> */}
                                        <td>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                </div>

                {/* <div className="imagen-modal-button-container">
                    <div className="cerrar-button" onClick={handleClose} style={{ cursor: "pointer" }}>
                        Cerrar
                    </div>
                    <div className="right-buttons">
                        <div className="agregar-button"
                            // onClick={onGuardar}
                            style={{ cursor: "pointer" }}>
                            Agregar
                        </div>
                    </div>
                </div> */}
            </div>
        </Modal>
    )
}
